// import React, { useRef, useState } from "react";
// import InviteModal from "../../components/inviteModal";
// import { Link } from "react-router-dom";

// const EmployeeToggleHeader = ({ isOffboarding, onToggleView, onAdd }) => {
//   const [open, setOpen] = useState(false);
//   const triggerRef = useRef(null);

//   function handleClose() {
//     setOpen(false);
//   }
//   return (
//     <div className=" w-full">
//       <div className="flex items-center justify-between font-Outfit py-4">
//         <div className="flex items-center gap-6">
//           <h2 className="text-lg font-semibold">
//             {isOffboarding ? (
//               "Offboarding"
//             ) : (
//               <>
//                 All <span>Employees</span>
//               </>
//             )}
//           </h2>

//           <button
//             onClick={() => onToggleView(!isOffboarding)}
//             className={`px-4 w-40 py-2 rounded-lg border text-xs transition ${
//               isOffboarding
//                 ? "bg-blue-500 text-white border-blue-500"
//                 : "bg-white text-black border-[#3C60FFB2]"
//             }`}
//           >
//             {isOffboarding ? "All Employees" : "Offboarding"}
//           </button>
//         </div>

//         <div className="flex gap-4">
//           <button
//             ref={triggerRef}
//             onClick={() => {
//               setOpen(true);
//               console.log("rrrrr");
//             }}
//             aria-controls="invite-modal" // optional: id of modal for assistive tech
//             aria-expanded={open}
//             className="w-36 py-3 px-6 rounded-xl border border-[#1234CD] text-[#1234CD]"
//           >
//             Invite
//           </button>

//           <Link to="/employee/new-employee">
//             <button className="w-36 py-3 px-6  rounded-xl bg-[#1234CD] text-white">
//               Add new
//             </button>
//           </Link>
//         </div>
//       </div>

//       <div className="flex gap-2">
//         <button className="w-28 py-2 px-4  rounded-xl bg-[#1234CD] text-white">
//           Approved
//         </button>
//         <button className="w-28 py-2 px-4 bg-white rounded-xl border border-[#3C60FFB2] text-black">
//           Pending
//         </button>
//       </div>

//       <InviteModal
//         isOpen={open}
//         onClose={handleClose}
//       />
//     </div>
//   );
// };

// export default EmployeeToggleHeader;

import React, { useContext, useRef, useState } from "react";
import InviteModal from "../../components/inviteModal";
import { SuccessModal } from "../../components/modal";
import { Link } from "react-router-dom";
import axios from "../../api/httpClient";
import { getApiBaseUrl } from "../../data/authStorage";
import { GlobalState } from "../../data/Context";

const EmployeeToggleHeader = ({
  selectedStatus = "approved",
  onStatusChange,
  inviteResponseFilter = "pending",
  onInviteResponseFilterChange,
  readOnly = false,
  title = "Employees",
  subtitle = "",
}) => {
  const [open, setOpen] = useState(false);
  const [inviteSummary, setInviteSummary] = useState(null);
  const [showInviteSummaryModal, setShowInviteSummaryModal] = useState(false);
  const triggerRef = useRef(null);
  const apiBaseUrl = getApiBaseUrl();
  const { organization } = useContext(GlobalState);

  const statusOptions = [
    { key: "approved", label: "Approved" },
    { key: "pending", label: "Pending" },
    { key: "offboarded", label: "Offboarded" },
    { key: "invited", label: "Invited" },
  ];

  const inviteFilters = [
    { key: "all", label: "All invited" },
    { key: "pending", label: "Pending response" },
    { key: "responded", label: "Responded" },
  ];

  function handleClose() {
    setOpen(false);
  }

  const handleSendInvite = async (emailsInput) => {
    if (!apiBaseUrl) {
      throw new Error("API base URL is not configured.");
    }

    const response = await axios.post(
      `${apiBaseUrl}/organizations/employees/invite`,
      {
        emails: emailsInput,
      },
    );

    setInviteSummary({
      summary: response?.data?.summary || null,
      failedDetails: response?.data?.failedDetails || [],
      title: response?.data?.confirmationModal?.title || "Invitation summary",
      subtitle:
        response?.data?.confirmationModal?.subtitle ||
        "Staff invite processing has completed",
      primaryActionLabel:
        response?.data?.confirmationModal?.primaryActionLabel ||
        "View invited staff",
    });
    setShowInviteSummaryModal(true);

    if (onStatusChange) {
      onStatusChange("invited", "pending");
    }

    onInviteResponseFilterChange?.("pending");

    return response;
  };

  return (
    <div className="w-full min-w-0 max-w-full font-Nunito">
      <div className="flex flex-col gap-4 py-4 md:flex-row md:items-center md:justify-between">
        <div>
          {!readOnly ? <nav aria-label="Employee type" className="inline-flex rounded-xl bg-slate-100 p-1">
            <button type="button" aria-current="page" className="rounded-lg bg-white px-6 py-2.5 text-sm font-bold text-[#1234CD] shadow-sm sm:text-base">Regular</button>
            <Link to="/contract-staff" className="rounded-lg px-6 py-2.5 text-sm font-semibold text-slate-500 transition hover:bg-white hover:text-[#1234CD] sm:text-base">Contract</Link>
          </nav> : <h2 className="text-lg font-bold text-black">{title}</h2>}
          {subtitle ? <p className="mt-2 text-sm text-gray-500">{subtitle}</p> : null}
        </div>

        {/* Actions */}
        {!readOnly ? <div className="flex w-full flex-row gap-2 sm:w-auto sm:gap-3">
          <button
            ref={triggerRef}
            onClick={() => setOpen(true)}
            aria-expanded={open}
            className="min-w-0 flex-1 rounded-xl border border-[#1234CD] px-4 py-2 text-sm text-[#1234CD] sm:w-36 sm:flex-none sm:px-6 sm:py-3 sm:text-base"
          >
            Invite
          </button>

          <Link
            to="/employee/new-employee"
            className="min-w-0 flex-1 sm:w-auto sm:flex-none"
          >
            <button className="w-full rounded-xl bg-[#1234CD] px-4 py-2 text-sm text-white sm:w-36 sm:px-6 sm:py-3 sm:text-base">
              Add new
            </button>
          </Link>
        </div> : null}
      </div>

      {/* Status filters */}
      {!readOnly ? <div className="flex max-w-full flex-nowrap items-center gap-2 overflow-x-auto pb-1 no-scrollbar">
        {statusOptions.map((status) => (
          <button
            key={status.key}
            type="button"
            onClick={() => onStatusChange?.(status.key)}
            className={`shrink-0 whitespace-nowrap py-2 px-4 rounded-xl border text-sm transition ${
              selectedStatus === status.key
                ? "bg-[#1234CD] text-white border-[#1234CD]"
                : "bg-white text-black border-[#3C60FFB2]"
            }`}
          >
            {status.label}
          </button>
        ))}
      </div> : null}

      {!readOnly && selectedStatus === "invited" ? (
        <div className="mt-3 flex max-w-full flex-nowrap items-center gap-2 overflow-x-auto pb-1 no-scrollbar">
          {inviteFilters.map((filter) => (
            <button
              key={filter.key}
              type="button"
              onClick={() => onInviteResponseFilterChange?.(filter.key)}
              className={`shrink-0 whitespace-nowrap rounded-xl border px-3 py-2 text-sm transition ${
                inviteResponseFilter === filter.key
                  ? "border-[#1234CD] bg-[#1234CD] text-white"
                  : "border-[#3C60FFB2] bg-white text-black"
              }`}
            >
              {filter.label}
            </button>
          ))}
        </div>
      ) : null}

      <InviteModal
        isOpen={open}
        onClose={handleClose}
        onSend={handleSendInvite}
        organizationName={organization?.name || "your organization"}
      />

      <SuccessModal
        isOpen={showInviteSummaryModal}
        onClose={() => setShowInviteSummaryModal(false)}
        onDone={() => {
          setShowInviteSummaryModal(false);
          onStatusChange?.("invited", "pending");
          onInviteResponseFilterChange?.("pending");
        }}
        doneLabel={inviteSummary?.primaryActionLabel || "View invited staff"}
        modalClassName="w-[560px] max-w-[92vw] h-auto min-h-0"
        bodyClassName="mt-3"
        actionsClassName="mt-6"
      >
        <div className="space-y-4 text-center font-Outfit">
          <h2 className="text-2xl font-semibold text-[#071C50]">
            {inviteSummary?.title || "Invitation summary"}
          </h2>
          <p className="text-sm text-gray-600">
            {inviteSummary?.subtitle || "Staff invite processing has completed"}
          </p>

          <div className="mx-auto grid max-w-[280px] grid-cols-2 gap-2 rounded-lg border border-gray-200 p-3 text-left text-sm">
            <div className="rounded-md bg-[#F5F7FF] p-2">
              <p className="text-gray-500">Sent</p>
              <p className="font-semibold text-[#071C50]">
                {inviteSummary?.summary?.sentCount || 0}
              </p>
            </div>
            <div className="rounded-md bg-[#F5F7FF] p-2">
              <p className="text-gray-500">Existing</p>
              <p className="font-semibold text-[#071C50]">
                {inviteSummary?.summary?.existingCount || 0}
              </p>
            </div>
            <div className="rounded-md bg-[#FFF4F4] p-2">
              <p className="text-gray-500">Invalid</p>
              <p className="font-semibold text-[#B42318]">
                {inviteSummary?.summary?.invalidCount || 0}
              </p>
            </div>
            <div className="rounded-md bg-[#FFF4F4] p-2">
              <p className="text-gray-500">Failed</p>
              <p className="font-semibold text-[#B42318]">
                {inviteSummary?.summary?.failedCount || 0}
              </p>
            </div>
          </div>

          {inviteSummary?.failedDetails?.length ? (
            <div className="mx-auto max-w-[420px] rounded-md border border-[#FECACA] bg-[#FFF1F2] p-3 text-left text-xs text-[#B42318]">
              <p className="font-semibold">Why some invites failed</p>
              {inviteSummary.failedDetails.slice(0, 3).map((item) => (
                <p
                  key={item.email}
                  className="mt-1 break-words"
                >
                  {item.email}: {item.reason}
                </p>
              ))}
              {inviteSummary.failedDetails.length > 3 ? (
                <p className="mt-1 text-[#7F1D1D]">
                  +{inviteSummary.failedDetails.length - 3} more in Invited list
                </p>
              ) : null}
            </div>
          ) : null}
        </div>
      </SuccessModal>
    </div>
  );
};

export default EmployeeToggleHeader;
